export type AiHubStatusTone = "green" | "yellow" | "blue" | "red";

const TONE_COLORS: Record<AiHubStatusTone, { bgcolor: string; color: string }> =
  {
    green: { bgcolor: "#E3F7F0", color: "#006642" },
    yellow: { bgcolor: "#FFF0B3", color: "#8E350C" },
    blue: { bgcolor: "#EEF2FF", color: "#295EF1" },
    red: { bgcolor: "#FDE2E2", color: "#B42318" },
  };

/** Pill used for Status values across AI Hub lists and detail pages. */
export function getAiHubStatusChipSx(tone: AiHubStatusTone) {
  return {
    height: 22,
    minWidth: 80,
    borderRadius: "16px",
    fontSize: 12,
    fontWeight: 500,
    justifyContent: "center",
    ...TONE_COLORS[tone],
    "& .MuiChip-label": {
      padding: "4px 8px",
      lineHeight: "14px",
      textAlign: "center",
    },
  };
}

/** Secondary action button on AI Hub detail pages. */
export const aiHubOutlinedButtonSx = {
  textTransform: "none",
  fontWeight: 500,
  borderRadius: "3px",
  height: 34,
  minHeight: 34,
  px: 1.75,
} as const;

/** Primary action button on AI Hub detail pages. */
export const aiHubContainedButtonSx = {
  borderRadius: "3px",
  height: 34,
  minHeight: 34,
} as const;
